import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { StepperNavigationService } from "../../../services/stepper-navigation.service";
import { ActivatedRoute } from "@angular/router";
import { CalcTemplate } from "../../../services/calctemplate";
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
} from "@cvx/nextpage";
import { Subject } from "rxjs";
import { Component_MAWP } from "../../../services/component_mawp";
import { GougeModule } from "../../../services/gouge_module";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { Form1 } from "../../../services/form1";
import { MatStepper } from "@angular/material/stepper";
import { WarningModalComponent } from "../../warning-modal/warning-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { Utility } from "../../../services/utility";
import { FormControlsEventProxyService } from "../../../services/formcontrols_eventproxy_service";
import { MatRadioChange } from "@angular/material/radio";
import { VerticalvesselComponent } from "../../type-a-component/verticalvessel/verticalvessel.component";
import { HorizontalvesselComponent } from "../../type-a-component/horizontalvessel/horizontalvessel.component";
import { CarbonsteelandlowalloysteelComponent } from "../../type-a-component/carbonsteelandlowalloysteel/carbonsteelandlowalloysteel.component";
import { HighalloyandnonferroussteelComponent } from "../../type-a-component/highalloyandnonferroussteel/highalloyandnonferroussteel.component";
import { Overlay } from "@angular/cdk/overlay";
import { ComponentEventService } from "projects/fitnessforservice/src/services/component_event.service";
import { MAEPComponent } from "../../maep/maep.component";
import { MAWPComponent } from "../../mawp/mawp.component";
import { Component_MAEP } from "projects/fitnessforservice/src/services/component_maep";
import { LTA_module } from "projects/fitnessforservice/src/services/lta_module";
import { ModuleConfigService, AssessmentModule } from "projects/fitnessforservice/src/services/module-config.service";

@Component({
    selector: "gouges",
    templateUrl: "gouges.component.html",
    standalone: false
})
export class GougesComponent implements OnInit {
  @ViewChild("stepper") private myStepper: MatStepper;
  private readonly stepNav = inject(StepperNavigationService);
    @ViewChild('mawpComponent') mawpComponent!: MAWPComponent;
    @ViewChild('maepComponent') maepComponent!: MAEPComponent;
  totalStepsCount: number;

  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  path: string;
  inspectionDataCalculate: Subject<boolean> = new Subject();
  applicability: string;

  public component_mawp = Component_MAWP;
  public gauges = GougeModule;
  reevaluSub: any;
   //Shameer 
 typeA : number;
 isreevalu = true;
// ComponentTypeData : Data[];
  tooltipText1: string = '';
  tooltipText2: string = '';
  tooltipText3: string = '';
  tooltipText4: string = ''; 
  intUnittype:number;

  summary: string;
  inspectionDataResult: string;
  result: string;

  SelectedValue: string;
  isCheckboxDisabled = false;
  isCylAtmradio = true; // always disabled this radio button for the current requirement
  showDIRequiredMessage: boolean = false;


  intUnit: number;

  material_toughness_data_enabled: boolean;
  material_toughness_determination_enabled: boolean;
  materialToughness: string = "yes";
  gougeDressed: string = "no";

  gougeValidationList = [];
  gougeValidationListLabel = "Check your input! \n\n";

  gougeWarningMessage = [];

  firstFormGroup = this._formBuilder.group({
    applicabilityCheckbox: ["", Validators.requiredTrue],
    typeACheckbox:["",Validators.required],
    radio:["",],
  });
  secondFormGroup = this._formBuilder.group({});
  isLinear = true;
  gougesTypeOfLoad_formGroup = this._formBuilder.group({
    radioButton_DI: [""],
  });

  curveMapping = {
    "Curve A": 0,
    "Curve B": 1,
    "Curve C": 2,
    "Curve D": 3,
  };

  gougesDataFormGroup = this._formBuilder.group({
    radioButton2_Gouge: ["", Validators.required],
    radioButton4_Gouge: [{ value: "", disabled: true }, Validators.required],
    textBox1_Gouge: [{ value: "", disabled: true }, Validators.required],
    textBox2_Gouge: [{ value: "", disabled: true }, Validators.required],
    textBox3_Gouge: [{ value: "", disabled: true }, Validators.required],
    comboBox1_Gouge: [{ value: "", disabled: true }, Validators.required],
  });

  constructor(
    private NP: NextPageService,
    private activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
    private componentService: ComponentEventService,
    private formControlsEventProxyService: FormControlsEventProxyService,
    private moduleConfigService: ModuleConfigService
  ) {
    this.path = activatedRoute.snapshot["_routerState"].url;
    this.Gouges_Assesment_Setup();
     //shameer   
     this.firstFormGroup.get('typeACheckbox').disable();
     this.firstFormGroup.get('applicabilityCheckbox').disable();
  }

  goToComponent() {

    if(((this.firstFormGroup.get('radio').value) != null) &&
    ((this.firstFormGroup.get('applicabilityCheckbox').enabled == true ) ||
    (this.firstFormGroup.get('typeACheckbox').enabled == true))
  )
  {
    this.firstFormGroup.controls["applicabilityCheckbox"].markAsDirty({
      onlySelf: true,
    });

     //shameer
     let typAcheckbox1 = this.firstFormGroup.controls["typeACheckbox"];
     typAcheckbox1.markAsDirty({
       onlySelf: true,
     });
     typAcheckbox1.markAsTouched({
       onlySelf: true,
     });

    this.goNextStep();
  } else{
    this.dialog.open(WarningModalComponent, {
      width: "450px",
      data: {
        warningMessage: [
          "Select an Option to Proceed!..Please.",
        ],
        caption: "FFS: Applicability and Limitations",
        captionCenter: true,
        cancelButtonShow: false,
            },
                                           });
         }
  }
  getApplicabilityCheckbox_formControl(): FormControl {
    return this.firstFormGroup.get("applicabilityCheckbox") as FormControl;
  }

  gettypeAcheckbox_formControl():FormControl {
    return this.firstFormGroup.get("typeACheckbox") as FormControl;
  }

  get isSphericalSelected(): boolean {
    return Number(this.firstFormGroup.get('radio')?.value) === 5;
  }

  ngOnInit(): void {
    // Set current module to Gouges for feature management
    this.moduleConfigService.setCurrentModule(AssessmentModule.GOUGES);

    CalcTemplate.reset_data();
    this.intUnit = parseInt(localStorage.getItem("unitType")) || 0;

    this.applicability = `  
          <ol>  
            <li>The original design criteria were in accordance with a recognized code or standard.</li>  
            <li>The component is not operating in the creep range. See the Help Menu for temperature limit used to define the creep range.</li>
            <li>The material is considered to have sufficient material toughness and the component is not subject to embrittlement during operation due to temperature and/or process environment. Note that cold work may be produced by the deformation. This cold worked area may be more susceptible to some forms of mechanical and environmental cracking.</li>  
            <li>The component is not in cyclic service (i.e., less than 150 cycles in past and future planned operation or satisfying the cyclic service screening criteria).</li>  
            <li>  
              Type A components subject to internal pressure. Type A components have a design equation that specifically relates pressure and/or other loads to a required wall thickness. Examples are:    
              <ol type="a">  
                <li>Pressure vessel cylindrical and conical shell sections satisfying the dimensions criteria</li>  
                <li>Spherical pressure vessels and storage spheres</li>  
                <li>Spherical, elliptical and torispherical formed heads</li>  
                <li>Straight sections of piping systems and elbows or pipe bends that do not have structural attachments satisfying the size and temperature criteria</li>  
                <li>Cylindrical atmospheric storage tank shell courses</li>  
              </ol>  
            </li>  
          </ol>  
        `;
    this.stepNav.resetToApplicability();

    this.formControlsEventProxyService.getGouges_ApplicabilityEventSubject().subscribe((v) => {
      this.updateApplicabilityCheckboxToChecked();
      this.firstFormGroup.get('applicabilityCheckbox').enable();
    });

    this.formControlsEventProxyService
    .getGougestypea_ApplicabilityEventSubject()
    .subscribe((v) => {
      this.updatetypeACheckboxToChecked();
      this.firstFormGroup.get('typeACheckbox').enable();
      
    });

    this.formControlsEventProxyService
    .getgougestypeAupdateradioSubject()
    .subscribe((v) => {
      this.updateradiobuttonafterimport();
      this.updatedamageafterimport();
      this.updatetooltip();
    });

    this.formControlsEventProxyService.getGougesDataEventSubject().subscribe((v) => {
      this.updateFormControlsAfterImport();
    });

    this.reevaluSub = this.componentService.reevaluButtonEnabled.subscribe(
      enabled => this.isreevalu = !enabled
    );
    this.componentService.typeDamageSelected$.subscribe(val => {
      this.gougesTypeOfLoad_formGroup.get('radioButton_DI').patchValue(val);
    });
  }

  updateradiobuttonafterimport()
  {
    
    this.firstFormGroup.get('radio').patchValue(this.componentService.typearadioselectedValue.toString());
  
  }
  updatedamageafterimport() {
      // After importing and updating the service value
    this.gougesTypeOfLoad_formGroup.get('radioButton_DI')
    .patchValue(this.componentService.typeDamageSelectedValue);
    }
  updatetooltip()
  {
   // this.tooltipText1 = this.componentService.typeatypeAinput1val.toString();

    const a1 = this.componentService.typeatypeAinput1val.toString();
    const a2 = this.componentService.typeatypeAinput2val.toString()

    const ut = this.componentService.typeAUnitTypeval.toString();
    const typaPF = this.componentService.typeAresultjsnval.toString();
    
    const Passres = "\n\nThe component meets the Type A screeing criteria";
    const Failres = "\n\nThe component doesn't meet the Type A screeing criteria.";    

    if(this.componentService.typearadioselectedValue.toString()== "1")
    {
      if (ut == "0")
      {
        const l1 = "Vertical Location of the Flaw, H (inch)";
        const l2 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch)";
      
        if(typaPF == "0")
        {
          this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
        }else if(typaPF == "1")
        {
          this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
        }
        
      }
      else if( ut == "1")
      {
        const l1 = "Vertical Location of the Flaw, H*  (mm) *";
        const l2 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
       
        if(typaPF == "0")
          {
            this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
      }

      this.tooltipText2 ="";
      this.tooltipText3 ="";
      this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "2")
    {
      if (ut == "0")
        {
          const l1 = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (inch) *";
          const l2 = "\nDistance between saddle supports Lss  (inch) *";
          
        if(typaPF == "0")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
         
        }
        else if( ut == "1")
        {
          const l1 = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
          const l2 = "\nDistance between saddle supports Lss  (mm) *";
          
        if(typaPF == "0")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }

        this.tooltipText1 ="";
        this.tooltipText3 ="";
        this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "3")
    {
      if (ut == "0")
        {
          const l1 = "Maximum Operating Temperature, Top  (℉)";
          const l2 = "\nPipe Nominal size, NPS  (inch)";
         
        if(typaPF == "0")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }
        else if( ut == "1")
        {
          const l1 = "Maximum Operating Temperature, Top  (℃)";
          const l2 = "\nPipe Nominal size, NPS  (mm)";
          
        if(typaPF == "0")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }
        this.tooltipText1 ="";
        this.tooltipText2 ="";
        this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "4")
    {
        if (ut == "0")
          {
            const l1 = "Maximum Operating Temperature, Top  (℉)";
            const l2 = "\nPipe Nominal size, NPS  (inch)";
           
        if(typaPF == "0")
          {
            this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
          }
          else if( ut == "1")
          {
            const l1 = "Maximum Operating Temperature, Top  (℃)";
            const l2 = "\nPipe Nominal size, NPS  (mm)";
           
            if(typaPF == "0")
              {
                this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
              }else if(typaPF == "1")
              {
                this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
              }
          }
          this.tooltipText1 ="";
          this.tooltipText2 ="";
          this.tooltipText3 ="";
     }
      else if (this.componentService.typearadioselectedValue.toString()== "5")
      {
          if (ut == "0")
            {
              
            }
            else if( ut == "1")
            {
              
            }
            this.tooltipText1 ="";
            this.tooltipText2 ="";
            this.tooltipText3 ="";
            this.tooltipText4 ="";
      }
      
  }
  updateApplicabilityCheckboxToChecked() {
    let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    applicabilityCheckbox.setValue(true);
  }
//shameer
updateApplicabilityCheckboxToUnChecked() {
  let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
  applicabilityCheckbox.setValue(false);
}
  goNextStep() {
    const applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    const typeACheckbox = this.gettypeAcheckbox_formControl();
    const accepted =
      applicabilityCheckbox.value === true || typeACheckbox.value === true;

    this.stepNav.next(this.myStepper, accepted);
  }

  goPreviousStep() {
    this.stepNav.previous(this.myStepper);
  }

  setTextBox1Value(textBox1_GougeformControl: FormControl) {
    if (GougeModule.sngCVN_value !== -1) {
      textBox1_GougeformControl.setValue(GougeModule.sngCVN_value.toString());
    }
  }

  setComboBox1Value(comboBox1_GougeformControl: FormControl) {
    if (GougeModule.intASME_curve !== -1) {
      const curveMapping = ["Curve A", "Curve B", "Curve C", "Curve D"];
      const curveValue = curveMapping[GougeModule.intASME_curve];
      if (curveValue) {
        comboBox1_GougeformControl.setValue(this.curveMapping[curveValue]);
      }
    }
  }

  setTextBox2Value(textBox2_GougeformControl: FormControl) {
    if (GougeModule.sngSMYS !== -1) {
      textBox2_GougeformControl.setValue(GougeModule.sngSMYS.toString());
    }
  }

  setTextBox3Value(textBox3_GougeformControl: FormControl) {
    if (GougeModule.sngT_op !== -1) {
      textBox3_GougeformControl.setValue(GougeModule.sngT_op.toString());
    }
  }

  updateFormControlsAfterImport() {
    let textBox1_GougeformControl: FormControl = this.gougesDataFormGroup.get("textBox1_Gouge") as FormControl;
    let textBox2_GougeformControl: FormControl = this.gougesDataFormGroup.get("textBox2_Gouge") as FormControl;
    let textBox3_GougeformControl: FormControl = this.gougesDataFormGroup.get("textBox3_Gouge") as FormControl;
    let comboBox1_GougeformControl: FormControl = this.gougesDataFormGroup.get("comboBox1_Gouge") as FormControl;
    let radioButton2_GougeformControl: FormControl = this.gougesDataFormGroup.get("radioButton2_Gouge") as FormControl;
    let radioButton4_GougeformControl: FormControl = this.gougesDataFormGroup.get("radioButton4_Gouge") as FormControl;

    this.setTextBox1Value(textBox1_GougeformControl);
    this.setComboBox1Value(comboBox1_GougeformControl);
    this.setTextBox2Value(textBox2_GougeformControl);
    this.setTextBox3Value(textBox3_GougeformControl);

    switch (GougeModule.intDressed) {
      case 1:
        radioButton2_GougeformControl.setValue("yes");
        this.doStepsAfterRadioButton2SetToYes();
        break;
      case 2:
        radioButton2_GougeformControl.setValue("no");
        this.doStepsAfterRadioButton2SetToNo();
        if (GougeModule.intCVN_data !== -1) {
          this.material_toughness_determination_enabled = true;
          switch (GougeModule.intCVN_data) {
            case 1:
              radioButton4_GougeformControl.setValue("yes");
              this.doStepsAfterRadioButton4SetToYes();
              break;
            case 2:
              radioButton4_GougeformControl.setValue("no");
              this.doStepsAfterRadioButton4SetToNo();
              break;
          }
        }
        break;
    }

    this.gougeValidationList = [];
  }

  Gouges_Assesment_Setup() {
    Component_MAWP.MAWP_initialize();

    Component_MAWP.strD_class = "Gouge";
    Component_MAWP.strD_iclass = 3;
    Component_MAWP.intUnit_select =
    parseInt(localStorage.getItem("unitType")) || 0;
    Form1.prev_strD_class = "Gouge";
    Component_MAEP.MAEP_initialize();
    Component_MAEP.strD_class = "Gouge";
    Component_MAEP.strD_iclass = 3;
    Component_MAEP.intUnit_select =
    parseInt(localStorage.getItem("unitType")) || 0;
    //GougeModule.Gouge_initialize();

    this.material_toughness_data_enabled = false;
    this.material_toughness_determination_enabled = false;
  }

  handleSummaryData(data: any) {
    this.summary = data;
  }

  handleInspectionData(data: any) {
    this.inspectionDataResult = data;
  }

  handleFormData(data: any) {
    // Placeholder to receive form data changes from MAWP/MAEP components
  }

  calculateGaouge(): void {
    Object.keys(this.gougesDataFormGroup.controls).forEach((key) => {
      if (this.gougesDataFormGroup.get(key).enabled) {
        this.gougesDataFormGroup.get(key).markAsDirty();
      }
    });

    let gougeValidationResultValid = GougeModule.check_Gouge_Data(
      this.gougesDataFormGroup
    );
    this.gougeValidationList = GougeModule.validationMessage;
    this.gougeWarningMessage = GougeModule.warningMessage;

    if (GougeModule.validationModalMessage.length != 0) {
      this.openErrorModal();
    }
    else if (this.gougesDataFormGroup.valid && gougeValidationResultValid) {
      if (this.gougeWarningMessage.length != 0) {
        this.openWarningModal();
      } else {
        GougeModule.Get_temp();
        this.goNextStep();
      }
    }
  }

  openWarningModal(): void {
    const dialogRef = this.dialog.open(WarningModalComponent, {
      width: "600px",
      data: {
        warningMessage: this.gougeWarningMessage,
        caption: "Proceed",
        captionCenter: true,
        cancelButtonShow: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // "OK"
        GougeModule.Get_temp();
        this.goNextStep();
      } // back
    });
  }

  openErrorModal(): void {
    const dialogRef = this.dialog.open(WarningModalComponent, {
      width: "600px",
      data: {
        warningMessage: GougeModule.validationModalMessage,
        caption: "Assessment Failed",
        captionCenter: true,
        cancelButtonShow: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // "OK"
        return;
      } // back
    });
  }

  calculateResult(): void {
    this.inspectionDataCalculate.next(true);
  }

 
onNextClickcalculateSummary() {
    const selected = this.gougesTypeOfLoad_formGroup.get('radioButton_DI')?.value;
    if (selected.toString().toUpperCase() === 'radioButton1_DI_enabled'.toString().toUpperCase()) {
      this.mawpComponent?.calculateSummary();
    } else if (selected.toString().toUpperCase() === 'radioButton2_DI_enabled'.toString().toUpperCase()) {
      this.maepComponent?.calculateSummary();
    } else {
      console.warn('Please select a pressure type.');
    }
  }
  goToMAWPComponent() {
    const diVal = this.gougesTypeOfLoad_formGroup.get('radioButton_DI')?.value;
    if (!diVal) {
      this.showDIRequiredMessage = true;
      this.gougesTypeOfLoad_formGroup.get('radioButton_DI')?.markAsTouched();
      this.gougesTypeOfLoad_formGroup.get('radioButton_DI')?.markAsDirty();
      return; // stay on Applied Load step
    }
    this.showDIRequiredMessage = false;
    // Proceed to the MAWP/MAEP step
    this.goNextStep();
  }
   goToMAEPComponent() {
        const diVal = this.gougesTypeOfLoad_formGroup.get('radioButton_DI')?.value;
        
        if (!diVal) {
          this.showDIRequiredMessage = true;
          this.gougesTypeOfLoad_formGroup.get('radioButton_DI')?.markAsTouched();
          this.gougesTypeOfLoad_formGroup.get('radioButton_DI')?.markAsDirty();
          return; // stay on Applied Load step
        }
        this.showDIRequiredMessage = false;
        this.goNextStep();
    }

  doStepsAfterRadioButton2SetToYes() {
    this.material_toughness_data_enabled = false;
    this.gougesDataFormGroup.controls.radioButton4_Gouge.disable();

    Object.keys(this.gougesDataFormGroup.controls).forEach((key) => {
      if (
        this.gougesDataFormGroup.get(key) !=
        this.gougesDataFormGroup.controls.radioButton2_Gouge
      ) {
        this.gougesDataFormGroup.get(key).disable();
        this.gougesDataFormGroup.get(key).setValue("");
        this.gougesDataFormGroup.get(key).markAsPristine();
        this.gougesDataFormGroup.get(key).markAsUntouched();
      }
    });
    this.gougesDataFormGroup.controls.comboBox1_Gouge.setValue("");
    this.material_toughness_determination_enabled = false;

  }

  doStepsAfterRadioButton2SetToNo() {
    this.material_toughness_data_enabled = true;
    this.gougesDataFormGroup.controls.radioButton4_Gouge.enable();
  }

  doStepsAfterRadioButton4SetToYes() {
    this.gougesDataFormGroup.controls.textBox1_Gouge.enable();

    this.gougesDataFormGroup.controls.textBox2_Gouge.disable();
    this.gougesDataFormGroup.controls.textBox3_Gouge.disable();
    this.gougesDataFormGroup.controls.comboBox1_Gouge.disable();
  }

  doStepsAfterRadioButton4SetToNo() {
    this.gougesDataFormGroup.controls.textBox1_Gouge.disable();

    this.gougesDataFormGroup.controls.textBox2_Gouge.enable();
    this.gougesDataFormGroup.controls.textBox3_Gouge.enable();
    this.gougesDataFormGroup.controls.comboBox1_Gouge.enable();
  }

  onChangeRadioButton2_Gouge(value: string) {
    this.gougeDressed = value;
    if (value === "yes") {
      GougeModule.intDressed = 1;

      this.onUpdateCurveValue(-1);
      GougeModule.sngCVN_value = -1;
      GougeModule.sngSMYS = -1;
      GougeModule.sngT_op = -1;

      this.doStepsAfterRadioButton2SetToYes()

      this.gougeValidationList = [];
      GougeModule.validationMessage = [];
    } else {
      this.gauges.intDressed = 2;
      this.doStepsAfterRadioButton2SetToNo();
    }
  }

  onChangeRadioButton4_Gouge(value: string) {
    this.material_toughness_determination_enabled = true;
    this.materialToughness = value;

    this.gougesDataFormGroup.controls.textBox1_Gouge.markAsPristine();
    this.gougesDataFormGroup.controls.textBox2_Gouge.markAsPristine();
    this.gougesDataFormGroup.controls.textBox3_Gouge.markAsPristine();
    this.gougesDataFormGroup.controls.comboBox1_Gouge.markAsPristine();

    this.gougeValidationList = [];
    GougeModule.validationMessage = [];

    if (value === "yes") {
      GougeModule.intCVN_data = 1;
      this.doStepsAfterRadioButton4SetToYes();
    } else {
      GougeModule.intCVN_data = 2;
      this.doStepsAfterRadioButton4SetToNo();
    }
  }

  onUpdateCurveValue(curveName: number): void {
    GougeModule.intASME_curve = curveName;
  }

  onChangeTextBox1_Gouge(e) {
    if (Utility.isTextADouble(e.target.value))
      GougeModule.sngCVN_value = parseFloat(e.target.value);
  }

  onChangeTextBox2_Gouge(e) {
    if (Utility.isTextADouble(e.target.value))
      GougeModule.sngSMYS = parseFloat(e.target.value);
  }

  onChangeTextBox3_Gouge(e) {
    if (Utility.isTextADouble(e.target.value))
      GougeModule.sngT_op = parseFloat(e.target.value);
  }

  onRadioChange(event:MatRadioChange)
  {
    console.log('Selected value',event.value);
    if(event.value ==1)
    {
      const dialogRef = this.dialog.open(VerticalvesselComponent,{height : '725px' ,width :'1200px', disableClose :true })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Data from dialog:', result.data1,result.data2); 
        if (result.cancel) {

          this.updateTypeAradioToUncheck();
          this.updateApplicabilityCheckboxToUnChecked();
          this.updatetypeACheckboxToUnChecked();
          this.firstFormGroup.get('applicabilityCheckbox').disable();
          this.firstFormGroup.get('typeACheckbox').disable();

           //clear all tool tips
           this.tooltipText1="";
           this.tooltipText2="";
           this.tooltipText3="";
           this.tooltipText4="";

        } else {
          console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
          if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
            {
                this.updateApplicabilityCheckboxToUnChecked();
                this.firstFormGroup.get('applicabilityCheckbox').disable();
                this.updatetypeACheckboxToUnChecked();
                this.firstFormGroup.get('typeACheckbox').enable();

                  //for typea result in report generation
                  localStorage.setItem("TypeAPassorFail","0");

                   //for enabling Reeval button
                this.isreevalu = false;
                //for removing tool tips of horizontal /carbon/highalloy  tooltip
                this.tooltipText2="";
                this.tooltipText3="";
                this.tooltipText4="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('verticalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;
                
               this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;

              }
            
            }
            else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
              {
                this.updateApplicabilityCheckboxToUnChecked();
                this.firstFormGroup.get('applicabilityCheckbox').enable();
                this.updatetypeACheckboxToUnChecked();
                this.firstFormGroup.get('typeACheckbox').disable();

                  //for typea result in report generation
                  localStorage.setItem("TypeAPassorFail","1");

                   //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of horizontal /carbon/highalloy  tooltip
                this.tooltipText2="";
                this.tooltipText3="";
                this.tooltipText4="";

                //for tooltip on vessels
                const userinputs = localStorage.getItem('verticalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
                const res = "\n\nThe component meets the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
                const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
                const res = "\n\nThe component meets the Type A screeing criteria."
                this.tooltipText1 = lbl1+a1+lbl2+a2+res;

              }

              }
        }
     
      }
    });  
    this.componentService.updateTypeASelectedValue(1); // as we selected vertical 
    localStorage.setItem("TypeAradioselection","1"); 
    }
    else if(event.value==2)
    {
      const dialogRef = this.dialog.open(HorizontalvesselComponent,{height : '650px' ,width :'1200px',disableClose :true})
     
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

              //clear all tool tips
              this.tooltipText1="";
              this.tooltipText2="";
              this.tooltipText3="";
              this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();

                    //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");

                  //for enabling Reeval button
                  this.isreevalu = false;
                  //for removing tool tips of vertical/carbon/highalloy  tooltip
                  this.tooltipText1="";
                  this.tooltipText3="";
                  this.tooltipText4="";
                 
  
  
                   //for tooltip on vessels
                   const userinputs = localStorage.getItem('horizontalinputs');
                   const Input_data = userinputs ? JSON.parse(userinputs) : null;
                   const a1 = Input_data.inputvalue1;
                   const a2 = Input_data.inputvalue2;
  
                   this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;
  
                 if(this.intUnittype==0) //us customary
                {
                  const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
                  const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
                  const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                  this.tooltipText2 = lbl1+a1+lbl2+a2+res;
                }
                else if(this.intUnittype == 1) //si units
                {
                  const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
                  const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
                  const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                  this.tooltipText2 = lbl1+a1+lbl2+a2+res;
  
                }
                            
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                     //for enabling Reeval button
                this.isreevalu = false;
                //for removing vertical/carbon/highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText3="";
                this.tooltipText4="";

                //for tooltip on vessels
                const userinputs = localStorage.getItem('horizontalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
                 const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText2 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
                 const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText2 = lbl1+a1+lbl2+a2+res;
 
               }

                    //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      this.componentService.updateTypeASelectedValue(2); // as we selected Horizontal
      localStorage.setItem("TypeAradioselection","2"); 
    }
    else if(event.value==3)
    {
      const dialogRef = this.dialog.open(CarbonsteelandlowalloysteelComponent,{height : '520px' ,width :'1200px',disableClose :true})
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

             //clear all tool tips
             this.tooltipText1="";
             this.tooltipText2="";
             this.tooltipText3="";
             this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();

                       //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of vertical/horizontal /highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText2="";
                this.tooltipText4="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('carbonsteelinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText3 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText3 = lbl1+a1+lbl2+a2+res;
 
               }

                    //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                     //for enabling Reeval button
                     this.isreevalu = false;

                     //for removing tool tips of vertical/horizontal /highalloy  tooltip
                     this.tooltipText1="";
                     this.tooltipText2="";
                     this.tooltipText4="";
     
     
                     //for tooltip on vessels
                     const userinputs = localStorage.getItem('carbonsteelinputs');
                     const Input_data = userinputs ? JSON.parse(userinputs) : null;
                     const a1 = Input_data.inputvalue1;
                     const a2 = Input_data.inputvalue2;
 
                     this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;
 
                    if(this.intUnittype==0) //us customary
                   {
                     const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                     const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                     const res = "\n\nThe component meets the Type A screeing criteria."
                     this.tooltipText3 = lbl1+a1+lbl2+a2+res;
                   }
                   else if(this.intUnittype == 1) //si units
                   {
                     const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                     const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                     const res = "\n\nThe component meets the Type A screeing criteria."
                     this.tooltipText3 = lbl1+a1+lbl2+a2+res;
     
                   }

                    //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      this.componentService.updateTypeASelectedValue(3); // as we selected carbon and low alloy
      localStorage.setItem("TypeAradioselection","3"); 
    }
    else if(event.value==4)
    {
       const dialogRef = this.dialog.open(HighalloyandnonferroussteelComponent,{height : '520px' ,width :'1200px', disableClose :true})
       dialogRef.afterClosed().subscribe(result => {
        if (result) {
          console.log('Data from dialog:', result.data1,result.data2); 
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

              //clear all tool tips
              this.tooltipText1="";
              this.tooltipText2="";
              this.tooltipText3="";
              this.tooltipText4="";

          } else {
            console.log(result.value); // 2- for Next button  and TypeAresult as it is passed or failed true/false
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();

                  
                  //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of vertical/horizontal /carbon tooltip
                this.tooltipText1="";
                this.tooltipText2="";
                this.tooltipText3="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('highalloyinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
 
               }

                    //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                    //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of vertical/horizontal /carbon tooltip
                this.tooltipText1="";
                this.tooltipText2="";
                this.tooltipText3="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('highalloyinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
 
               }

                    //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      this.componentService.updateTypeASelectedValue(4);// as we selected HighAlloy
      localStorage.setItem("TypeAradioselection","4"); 
    }
    else
    {   
      
      if(event.value==5)  // when 2nd radio button is selected , consider typeA as passed
      {

           //for enabling Reeval button
           this.isreevalu = false;

           //clear all tool tips
           this.tooltipText1="";
           this.tooltipText2="";
           this.tooltipText3="";
           this.tooltipText4="";

         //for typea result in report generation
         localStorage.setItem("TypeAPassorFail","1");

        // Spherical components support only Internal Pressure.
        this.onChangeRadioButton1_DI('radioButton1_DI_enabled');
      }
      // when we select 5 or 6 or 7 radio buttons
       this.updateApplicabilityCheckboxToUnChecked();
       this.firstFormGroup.get('applicabilityCheckbox').enable();
       this.updatetypeACheckboxToUnChecked();
       this.firstFormGroup.get('typeACheckbox').disable();
       this.componentService.updateTypeASelectedValue(5); // as we selected Spherical components
       localStorage.setItem("TypeAradioselection","5"); 
    }
   
  }

  updateTypeAradioToUncheck()
  {
    this.firstFormGroup.get('radio').patchValue(null);    
  }

  gettypeAradio_formControl(): FormControl {
    return this.firstFormGroup.get("radio") as FormControl;
  }

  updatetypeACheckboxToChecked(){
    let typeAcheckbox = this.gettypeACheckbox_formControl();
    typeAcheckbox.setValue(true);
  }

  updatetypeACheckboxToUnChecked(){
    let typeAcheckbox = this.gettypeACheckbox_formControl();
    typeAcheckbox.setValue(false);
  }
  gettypeACheckbox_formControl(): FormControl {
    return this.firstFormGroup.get("typeACheckbox") as FormControl;
  }

  typeareevaluate()
  {
    this.updateTypeAradioToUncheck();
    this.updateApplicabilityCheckboxToUnChecked();
    this.updatetypeACheckboxToUnChecked();
    this.firstFormGroup.get('applicabilityCheckbox').disable();
    this.firstFormGroup.get('typeACheckbox').disable();
    
    //for disbling Reeval button
    this.isreevalu = true;
    this.tooltipText1="";
    this.tooltipText2="";
    this.tooltipText3="";
    this.tooltipText4="";
    localStorage.removeItem('verticalinputs');

    
   
  }
    async onChangeRadioButton1_DI(value: string) {
      const previousValue = this.componentService.radioButtonDI;

        // Save the value in your form if needed
        this.gougesTypeOfLoad_formGroup.get('radioButton_DI').setValue(value);

      // When switching Internal/External, force component-type dropdowns back to Select Type
      // and clear data in subsequent screens to avoid calculation errors.
      if (previousValue && previousValue !== value) {
        const confirmed = await this.componentService.confirmAssessmentContextChange();
        if (!confirmed) {
          this.gougesTypeOfLoad_formGroup.get('radioButton_DI').setValue(previousValue);
          return;
        }
        Component_MAWP.intEquip = -1;
        Component_MAEP.intEquip = -1;
        this.componentService.updateCompMAWPintEquip(-1);
        this.componentService.updateCompMAEPintEquip(-1);
        // Reset module and component data to prevent stale data in next screens
        Component_MAWP.MAWP_initialize();
        Component_MAEP.MAEP_initialize();
        GougeModule.Gouge_initialize();
        LTA_module.LTA_initialize();
        this.summary = "";
        this.inspectionDataResult = "";
        this.result = "";
        this.gougeValidationList = [];
        this.componentService.notifySilentAssessmentContextReset();
      }

        this.showDIRequiredMessage = false;
    
        // Set LML_module.intLoadingType based on selection
        if (value.toString().toUpperCase() === 'RADIOBUTTON1_DI_ENABLED') {
            LTA_module.intLoadingType = 0; // Internal Pressure
            // Store radio button value in both components
             Component_MAWP.strRadio = 0;
             Component_MAEP.strRadio = 0;
            Component_MAWP.strD_class = "Gouge";
            Component_MAWP.strD_iclass = 3;
            Component_MAWP.intUnit_select =
            parseInt(localStorage.getItem("unitType")) || 0;
            Form1.prev_strD_class = "Gouge";
        } else if (value.toString().toUpperCase() === 'RADIOBUTTON2_DI_ENABLED') {
            LTA_module.intLoadingType = 1; // External Pressure
            // // Store radio button value in both components
            Component_MAWP.strRadio = 1;
            Component_MAEP.strRadio = 1;
            Component_MAEP.MAEP_initialize();
            Component_MAEP.strD_class = "Gouge";
            Component_MAEP.strD_iclass = 3;
            Component_MAEP.intUnit_select =
            parseInt(localStorage.getItem("unitType")) || 0;
        }
        // Store in service instead of localStorage
         this.componentService.radioButtonDI = value;
      }

}
